export const rentalStructureTypes = [
    {
        display: '',
        value: '0',
    },
    {
        display: 'Detached House',
        value: '1',
    },
    {
        display: 'Townhouse',
        value: '2',
    },
    {
        display: 'Duplex',
        value: '3',
    },
    {
        display: 'Triplex',
        value: '4',
    },
    {
        display: 'Quadplex',
        value: '5',
    },
    {
        display: '5+ Unit',
        value: '6',
    },
    {
        display: 'Single Condo Unit in Larger Structure',
        value: '7',
    },
];
